import { useTheme } from "@mui/material";
import * as React from "react";

const Tickmark = (props) => {
  const theme = useTheme();
  const tickColor = theme?.palette?.success?.main;
  const circleColor = theme?.palette?.success?.light;

  return (
    <svg
      width={59}
      height={52}
      viewBox="0 0 59 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.089 51.5385C35.3316 51.5385 45.2562 41.605 45.2562 29.3514C45.2562 17.0978 35.3316 7.16431 23.089 7.16431C10.8464 7.16431 0.921875 17.0978 0.921875 29.3514C0.921875 41.605 10.8464 51.5385 23.089 51.5385Z"
        fill={circleColor}
      />
      <path
        d="M23.339 46.5004L23.0579 46.0209C18.7631 38.6968 7.35023 23.154 7.23495 22.9979L7.07031 22.7741L10.9586 18.9279L23.2668 27.5301C31.0164 17.4649 38.2462 10.5516 42.9622 6.51447C48.1211 2.0983 51.4792 0.0652342 51.5131 0.045752L51.5895 0H58.1851L57.5551 0.56159C41.3518 15.0068 23.7891 45.7088 23.6142 46.0172L23.339 46.5004Z"
        fill={tickColor}
      />
    </svg>
  );
};

export default Tickmark;